module.exports = __webpack_public_path__ + "img/gif_pruebas_nacionales.31668c83.gif";